import { useState } from "react";


function Input(props) {
    const [error, setError] = useState([]);
    const [showError, setShowError] = useState(false);
    const [showEmailError, setShowEmailError] = useState(false);

    function changeHandler(e) {
        const errors = [];
        const { value } = e.target;

        if (props.type === 'text') {
            let match = value.match(/[^a-zA-Z\s]/g);
            if (match && match.length > 0) {
                errors.push('Only text allowed!')
            }
        }

        if (props.type === 'number' && value < props.min && value !== '') {
            errors.push(`Value can not be negative!`)
        }

        if (props.type === 'phone') {
            const containsAlphabet = /[a-zA-Z]/.test(value);
            if (containsAlphabet) {
                errors.push('Only number allowed!')
            }
        }

        if (props.type === 'date') {
            if (props.min && new Date(value).getTime() < new Date(props.min).getTime()) {
                errors.push(`Past dates can not be selected!`)
            } else if (props.max && new Date(value).getTime() > new Date(props.max).getTime()) {
                errors.push(`Future dates can not be selected!`)
            }
        }


        if (errors.length === 0) {
            props.onChange(e);
            setError([]);
            let inputErrors = [...props.inputErrors];
            inputErrors[props.index] = '';
            props.setInputErrors(inputErrors);
        } else {
            setError(errors);
            let inputErrors = [...props.inputErrors];
            inputErrors[props.index] = 'error';
            props.setInputErrors(inputErrors);
        }
    }

    function blurHandler(e) {
        const { value } = e.target;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


        if (props.type === 'email') {
            if (value === '') {
                setShowError(true)
            }
            else if (regex.test(value)) {
                setShowEmailError(false);
                setShowError(false);
            } else {
                setShowEmailError(true);
                setShowError(true);
            }
        } else {
            if (value === '') {
                if (props.required) setShowError(true)
            } else {
                if (props.required) setShowError(false)
            }
        }
    }

    return (
        <div className="w-full">
            <div className="w-full">
                <div className="flex flex-row">
                    {props.required === true && props.name !== "image" && props.name !== "logoImage" && props.name !== "ebook" && <span className="text-red-500">*</span>}
                    <input
                        id={props.id || ''}
                        name={props.name}
                        value={props.value}
                        className={props.className}
                        type={props.type || ''}
                        min={props.min || ''}
                        minLength={props.minLength || ''}
                        maxLength={props.maxLength || ''}
                        placeholder={props.placeHolder}
                        required={props.required}
                        disabled={props.disabled}
                        accept={props.accept}
                        onChange={(e) => changeHandler(e)}
                        onBlur={e => blurHandler(e)}
                    />
                </div>
            </div>
            <div className="flex">
                <div className="text-red-500 text-xs font-semibold px-2 ">
                    {
                        (showError || props.missingFields && props.missingFields.includes(props.name)) && 'Required field!'
                    }
                </div>
                <div className="text-red-500 text-xs font-semibold px-2 ">
                    {error}
                </div>
                <div className="text-red-500 text-xs font-semibold px-2 ">
                    {
                        showEmailError && 'Please enter a valid Email!'
                    }
                </div>
            </div>
        </div>
    )
}

export default Input;